export const adminObjects = {
  TLS_ACCOUNTS: 'TLS Accounts',
  BOOK_TO_TAX_CODE_DESCRIPTIONS: 'Book to Tax Code Descriptions',
  BSM_ACCOUNT: 'BSM - Account',
  BSM_TAX_ENTRY: 'BSM - Tax Entry',
  BSM_GL_ACCOUNT_LIST: 'BSM - GL Account List',
  BSM_GL_ACCOUNT_MAP: 'BSM - GL Account Map',
  BSM_GL_JOURNAL: 'BSM - GL Journal',
  COMPANY_CODES: 'Company Codes',
  TAX_RATES: 'Tax Rates',
};
